import React from "react";
import { Button } from "./Button";
import flecha from "../../assets/Elipse.png";
import carrersBackground from "../../assets/carrersBackground.png";
import { motion } from "framer-motion";

interface CarrersHomeProps {
  scrollTo: (ref: React.RefObject<HTMLDivElement>) => void;
  goToSelectionRef: React.RefObject<HTMLDivElement>;
  goToSelectionRef2: React.RefObject<HTMLDivElement>;
}
export const CarrersHero: React.FC<CarrersHomeProps> = ({
  scrollTo,
  goToSelectionRef,
  goToSelectionRef2,
}) => {
  return (
    <>
      <div
        className="relative min-h-screen flex flex-col justify-center items-center text-white z-0 py-20 px-5 md:px-0"
        style={{
          backgroundImage: `url(${carrersBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
        }}
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8 px-[5%] md:px-0 z-10"
        >
          <span className="font-bold font-baskerville italic text-4xl md:text-[60px] leading-[96.4%]">
            ATRÉVETE
          </span>
          <span className="font-bold text-4xl md:text-[60px] leading-[96.4%]">
            {" "}
            A
          </span>
          <br />
          <span className="font-bold text-4xl md:text-[60px] leading-[96.4%]">
            {" "}
            CAMBIAR LAS <br />
            <span className="font-bold text-4xl md:text-[60px] leading-[96.4%]">
              REGLAS DEL JUEGO
            </span>
          </span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-sm md:text-base leading-6"
          >
            ¡En Peña Defilló{" "}
            <span className="font-bold text-sm md:text-base leading-6">
              jugamos, trabajamos y ganamos!
            </span>
          </motion.span>
          <br />
          <motion.span className="text-sm md:text-base leading-6">
            ¿Suena como el tipo de lugar en el que te gustaría
          </motion.span>
          <br />
          <motion.span className="text-sm md:text-base leading-6">
            estar?{" "}
            <span className="font-bold text-sm md:text-base leading-6">
              Nos encantaría conocerte.
            </span>
          </motion.span>
        </motion.div>

        <Button
          customClass="mt-4 bg-white text-black font-medium border-white rounded-none w-64 md:w-[252px]"
          onClick={() => scrollTo(goToSelectionRef)}
        >
          Ver puestos
        </Button>
        <img
          onClick={() => scrollTo(goToSelectionRef2)}
          draggable={false}
          className="absolute right-5 bottom-5 w-12 md:w-[50px] z-10 cursor-pointer animate-bounce pt-2"
          src={flecha}
          alt="Scroll down arrow"
        />
      </div>
    </>
  );
};
export default CarrersHero;
